import { Injectable } from "@angular/core";


@Injectable()
export class AppModalUseCase {
    modalFindErrorMessages(): [string, string, string, string] {
        return ['Lo sentimos', 'error', 'En este momento presentamos intermitencias con la plataforma, estamos trabajando para solucionarlo lo antes posible.', 'Lamentamos las molestias ocasionadas.'];
    }
}